/**
 * @项目名称: work
 * @功能名称: 错误码转换
 * @文件名称: translateCode
 * @Date: 2020/6/11
 * @Author: liux
 * @Copyright（C）2020 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
'use strict'
// 网关需要转换的错误码
const gatewayCodeMap = {
  40001: -4,
}

// 不做转code操作的地址 
const ignoreUrl = ['https://opengw.xiaoying.com/api/pay.uc.uc_login/v1','https://opengw.xiaoying.com/api/pay.uc.uc_register/v1']
const ignoreUrlRegExp = new RegExp(ignoreUrl.join('|'))
export default function (data, url) {
  // post 方法对errcode 做判断 如果存在会调reject 但是bjxy-login 没有catch 只是根据code判断 所以不能转译这两个地址的url
  // 针对登录注册的网关接口不做转译处理
  if(ignoreUrlRegExp.test(url)) return data;
  // /gateway 开头的接口是网关的
  if (/\.com\/gateway|opengw.xiaoying.com\/api/.test(url)){
    if(data.errcode === undefined && data.code !== undefined){
      data.errcode = gatewayCodeMap[data.code] || data.code
      data.errstr = data.message || data.msg ||  ''
      delete data.code;
      delete data.message;
    }
    return data
  }
  return data
}
